import makeStyles from '@mui/styles/makeStyles'
import { StatusMap } from '../components/status'

export const useStyles = makeStyles(({ typography, palette }) => ({
  root: {},
  avatar: {
    width: 43,
    height: 43,
    background: palette.white.off,
    border: '0.6px solid #DDDBE0',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  email: {
    fontWeight: typography.fontWeightMedium
  },
  status: {
    color: ({ state }) => state ? StatusMap[state].color : palette.text.secondary
  }
}))
